import React, { PureComponent } from 'react';
import axios from 'axios';
import { useTranslation, withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
// import google from 'googleapis';
import ReactLoading from "react-loading";
import Header from './Header.js'
import Footer from './Footer.js'
import BoxSearch from './BoxSearch.js'
import Menu from './Menu.js';
import LoginDialog from './LoginDialog.js';
import { initAuthToken, applyAuthToken, clearAuthToken, setupAuthInterceptor } from '../common/authToken.js';
import CopyrightPage from '../pages/CopyrightPage/CopyrightPage.js';

import HomePage from '../pages/HomePage/HomePage.js'
import LoginPage from '../pages/LoginPage/LoginPage.js'
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage.js'
import VipPage from '../pages/VipPage.js'
import NotFoundPage from '../pages/NotFoundPage.js'
import RecordingPage from '../pages/RecordingPage/RecordingPage.js'
import LiveroomPage from '../pages/LiveroomPage/LiveroomPage.js'
import PostPage from '../pages/PostPage/PostPage.js';
import UserPage from '../pages/UserPage/UserPage.js'
import TopUsersPage from '../pages/TopUsersPage/TopUsersPage.js'
import SearchPage from '../pages/SearchPage.js'
import BuyICoinPage from '../pages/BuyICoinPage/BuyICoinPage.js'
import TopRecordingsPage from '../pages/TopRecordingsPage/TopRecordingsPage.js';
import TopDuetRecordingsPage from '../pages/TopDuetRecordingsPage/TopDuetRecordingPage.js';
import PromotionManagerPage from '../pages/PromotionManagerPage/PromotionManagerPage.js';
import BannerManagerPage from '../pages/BannerManagerPage/BannerManagerPage.js';
import PackageManagerPage from '../pages/PackageManagerPage/PackageManagerPage.js';
import AccountManagerPage from '../pages/AccountManagerPage/AccountManagerPage.js';
import ProfilePage from '../pages/ProfilePage/ProfilePage.js';
import TransactionManagerPage from '../pages/RechargeManagerPage/TransactionManagerPage.js';
import MyGiftsPage from '../pages/MyGiftsPage/MyGiftsPage.js';
import UploadBeatPage from '../pages/UploadBeatPage/UploadBeatPage.js';
import MyImagesPage from '../pages/MyImagesPage/MyImagesPage.js';
import MyRecordingPage from '../pages/MyRecordingsPage/MyRecordingsPage.js';
import GiftManagerPage from '../pages/GiftManagerPage/GiftManagerPage';
import UpdateCupPage from '../pages/UpdateCupPage/UpdateCupPage.js';
import MixRecordingPage from '../pages/MixRecordingPage/MixedRecordingPage.js';
import TermPage from '../pages/TermPage.js';
import BeatManagerPage from '../pages/BeatManagerPage/BeatManagerPage.js';
import NotifyPage from '../pages/NotifyPage/NotifyPage.js';
import NotifyManagement from '../pages/NotifyManagement/NotifyManagement.js';
import AddIconForEventPage from '../pages/AddIconForEventPage/AddIconForEventPage.js';
import YoutubeSong from '../pages/Category/YoutubeSong.js';
import CompetitionPage from '../pages/CompetitionPage/CompetitionPage.js';

import RankItemPage from '../pages/RankItemPage/RankItemPage.js';
import VipPrivilege from '../pages/VipPrivilegePage/VipPrivilege.js';
import TestPage from '../pages/TestPage/TestPage.js';
import AvatarFrame from '../pages/ItemShopPage/AvatarFrame/AvatarFrame.js';
import CommentFrame from '../pages/ItemShopPage/CommentFrame/CommentFrame.js';
import RoomEntryEffect from '../pages/ItemShopPage/RoomEntryEffect/RoomEntryEffect.js';
import PersonalCard from '../pages/ItemShopPage/PersonalCard/PersonalCard.js';
import UserDecoration from '../pages/ItemShopPage/UserDecoration/UserDecoration.js';
import RecordingVipUsers from '../pages/RecordingVipUsers/RecordingVipUsers.js';
import SpecialGiftDiscountPage from '../pages/SpecialGiftDiscount/SpecialGiftDiscountPage.js'
import BOTFollowing from '../pages/BOTManagerPage/BOTFollowing.js';
import SmartLookManager from '../pages/SmartLookManager/SmartLookManager.js';
import RoomEventPage from '../pages/RoomEventPage/RoomEventPage.js';



import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    withRouter
} from "react-router-dom";

import { isAdminPortalHostname } from '../common/homeUrlByHost.js';
import ScrollToTop from './ScrollToTop.js';
import MyContextProvider from './MyContextProvider';
import { FacebookProvider } from 'react-facebook';

import { setCookie, deleteAllCookies } from "../common/cookie.js";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import DownloadPage from '../pages/DownloadPage/DownloadPage.js';
import SupportUser from '../pages/ChatForAdminPage/SupportUser.js';
import SubscribeConsoleLogPage from '../pages/SubscribeConsoleLogPage/SubscribeConsoloLogPage.js';
import OkaraConsoleLogPage from '../pages/OkaraConsoleLogPage/OkaraConsoleLogPage.js';
import LuckyGiftManagerPage from '../pages/LuckyManagerPage/LuckyGiftManagerPage.js';
import PostFanpagePage from '../pages/PostFanpagePage/PostFanpagePage.js';
import RankGiftPage from '../pages/RankGiftPage/RankGiftPage.js';
import MinigameManagerPage from '../pages/MinigameManagerPage/MinigameManagerPage.js';
import PushNotificationPage from '../pages/PushNotificationPage/PushNotificationPage.js';
import {detectMob, detectApp} from '../common/utils.js';
import { getThemeColor } from '../common/utils';
import SubscribeOkaraDialog from './SubscribeOkaraDialog.js';
import ConfirmSubscribeOkaraDialog from './ConfirmSubscribeOkaraDialog.js';
import UnsubscribeOkaraDialog from './UnsubscribeOkaraDialog.js';
import EvenLevelPrivilege from '../pages/EvenLevelPrivilege/EvenLevelPrivilegePage.js';

import '../assets/css/bootstrap.min.css';
import '../assets/css/css.css';
import '../assets/css/comment.css';
import '../assets/css/player.css';
import "../assets/css/style.css";
import "../assets/css/header.css";
import '../assets/css/toprecordhome.css';

import $ from 'jquery';
import PhoneVetificationDialog from './PhoneVetificationDialog.js';
import ConfirmPhoneVetificationDialog from './ConfirmPhoneVetificationDialog.js';
import RegisterPhoneDialog from './RegisterPhoneDialog.js';
import GenerateLinkPage from '../pages/GeneateLinkPage/GenerateLinkPage.js';
import SingButton from './SingButton.js';
import BannerFullPageManager from './../pages/BannerFullManagerPage/BannerFullPageManager';
import TopVipUserOfThisMonth from '../pages/TopVipUserOfThisMonth/TopVipUserOfThisMonth.js';
import SetPrivilegeAdmin from './../pages/SetPrivilegeAdminPage/SetPrivilegeAdmin';
import LuckyGiftManager from '../pages/LuckyGiftGaveManager/LuckyGiftGaveManager.js';
import LevelPrivilege from '../pages/LevelPrivilegePage/LevelPrivilege.js';
import DecorationItemType from '../pages/DecorationItemTypePage/DecorationItemType.js';
import CouplePage from './../pages/CouplePage/CouplePage';
import AdminPage from './AdminPage.js';
import ErrorPage from '../pages/ErrorPage.js';
import MedalManagerPage from '../pages/MedalManagerPage/MedalManagerPage.js';
import DeepARFilterPage from '../pages/DeepARFilterPage/DeepARFilterPage.js';
import DeepAREffectPage from '../pages/DeepAREffectPage/DeepAREffectPage.js';
import DeletedGiftPage from '../pages/GiftManagerPage/DeletedGiftPage.js';
import BirthdayGiftManager from '../pages/BirthdayGiftPage/BirthdayGiftManager.js';
import WebViewPage from '../pages/WebViewPage/WebViewPage.js';
import SingEffect from '../pages/ItemShopPage/SingEffect/SingEffect.js';
import SurveyPage from '../pages/SurveyPage/SurveyPage.js';
import ScreenManagerPage from '../pages/ScreenManagerPage/ScreenManagerPage.js';
import AppPolicyPage from '../pages/AppPolicyPage/AppPolicyPage.js';
import SendCupHistoryPage from '../pages/SendCupHistoryPage/SendCupHistoryPage.js';
import GameManagerPage from '../pages/GameManagerPage/GameManagerPage.js';
import CreateAndUpdateGameTypePage from '../pages/GameManagerPage/ChildrenPage/CreateAndUpdateGameTypePage/CreateAndUpdateGameTypePage.js';
import CreateAndUpdateGameLevelPage from '../pages/GameManagerPage/ChildrenPage/CreateAndUpdateGameLevelPage/CreateAndUpdateGameLevelPage.js';
import RecordingVipPage from '../pages/RecordingVipPage/RecordingVipPage.js';
import UserSpecialGiftPage from '../pages/UserSpecialGiftPage/UserSpecialGiftPage.js';
import AddRecordingVipPage from '../pages/RecordingVipPage/ChildrenPage/AddRecordingVipPage/AddRecordingVipPage.js';
import DetailRecordingVipPage from '../pages/RecordingVipPage/ChildrenPage/DetailRecordingVipPage/DetailRecordingVipPage.js';
import RecordingVipStatiticPage from '../pages/RecordingVipStatiticPage/index.js'
import TheVoiceExamnerPage from '../pages/TheVoiceExamnerPage/TheVoiceExamnerPage.js'; 
import Item3DPage from '../pages/Item3DPage/Item3DPage.js'; 
import SellerPage from '../pages/SellerPage/SellerPage.js'; 
import ManagerSellerPage from '../pages/ManagerSellerPage/ManagerSellerPage.js';
import LivestreamPage from '../pages/LivestreamPage/LivestreamPage.js'; 
import ContentEventPage from '../pages/ContentEventPage/ContentEventPage.js'; 
import FeatureRequestPage from '../pages/FeatureRequestPage/FeatureRequestPage.js'; 
import AddYoutubeMidiPage from '../pages/YoutubeMidiPage/ChildrenPage/AddYoutubeMidiPage/AddYoutubeMidiPage.js';
import DetailYoutubeMidiPage from '../pages/YoutubeMidiPage/ChildrenPage/DetailYoutubeMidiPage/DetailYoutubeMidiPage.js';
import YoutubeMidiPage from '../pages/YoutubeMidiPage/YoutubeMidiPage.js';
import UserPostPage from '../pages/UserPostPage/UserPostPage.js';
import HashtagPage from '../pages/HashtagPage/HashtagPage.js';
import RealGiftPage from '../pages/RealGiftPage/RealGiftPage.js';
import BannerSellMicPage from '../pages/BannerSellMicPage/BannerSellMicPage.js';
import PromoBannerSellMicPage from '../pages/PromoBannerSellMicPage/PromoBannerSellMicPage.js';
import RecheckApplePage from '../pages/RecheckApplePage/RecheckApplePage.js';
import WinRateFishHunterPage from '../pages/FishHunterManager/WinRateFishHunterPage.js';
import LinkedAccountPage from '../pages/LinkedAccountPage/LinkedAccountPage.js';
import GiftLevelManagerPage from '../pages/GiftLevelManagePage/GiftLevelManagerPage.js';
import SellerId from '../pages/ManagerSellerPage/components/SellerId.js';
import ManagerNewDevice from '../pages/ManagerNewDevice/components/ManagerNewDevice.js';
import ManagerHotMv from '../pages/ManagerHotMv/ManagerHotMv.js';
import SupportNewUser from '../pages/ChatForAdminPage/SupportNewUser.js';
import ManagerDeadAccount from '../pages/ManagerDeadAccount/ManagerDeadAccount.js';
import ListRecordingOfAccount from '../pages/ManagerDeadAccount/components/ListRecordingOfAccount.js';
import BOTManagerPage from '../pages/BOTManagerPage/BOTManagerPage.js';
import BOTInteractManagerPage from '../pages/BOTInteractManagerPage/BOTInteractManagerPage.js';
import BOTLiveRoomManagerPage from '../pages/BOTLiveRoomManagerPage/BOTLiveRoomManagerPage.js';
import CustomerSupportBotPage from '../pages/CustomerSupportBotPage/CustomerSupportBotPage.js';
import TopBeatPage from '../pages/TopBeatManagerPage/TopBeatPage.js';
import ListChatSupportUser from '../pages/ChatForAdminPage/ListChatSupportUser.js';
import IdolRecording from '../pages/IdolRecording/IdolRecording.js'
import BotRecording from '../pages/BotRecording/BotRecordingPage.js'
import IdolManagerPage from '../pages/IdolManagerPage/IdolManagerPage.js';
import AvatarChangePage from '../pages/AccountManagerPage/components/AvatarChangePage.js';
import DailyTaskPage from '../pages/DailyTaskManagerPage/DailyTaskPage.js';
import MidiRecordingPage from '../pages/MidiRecordingManager/MidiRecordingPage.js';
import MidiRecordingDetail from '../pages/MidiRecordingManager/component/MidiRecordingDetail.js';
import ClientLogPage from '../pages/ClientLogPage/ClientLogPage.js';
import ClientLogDetailPage from '../pages/ClientLogPage/ClientLogDetailPage.js';
import TopVideoRecordingPage from '../pages/TopVideoRecordingsPage/TopVideoRecordingPage.js';
import SurveyNPSPage from '../pages/SurveyNPS/SurveyNPSPage.js';
import DiceGameInfoHistory from '../pages/DiceGameInfoHistory/DiceGameInfoHistory.js';
import DiceUserHistoryPage from '../pages/DiceUserHistory/DiceUserHistoryPage.js';
import DiceBetClientFailsPage from '../pages/DiceBetClientFails/DiceBetClientFailsPage.js';
import VirtualBackgroundPage from '../pages/VirtualBackground/VirtualBackgroundPage.js';
import LiveRoomInfo from '../pages/LiveRoomInfo/LiveRoomInfo.js';
import PartnerManagerPage from '../pages/PartnerPage/PartnerManagerPage.js';
import PartnerIcoinDetail from '../pages/PartnerPage/PartnerIcoinDetail.js';
import ManageVietcomBank from "../pages/ManageVietcomBank/ManageVietcomBank.js";
import ManageVietinBank from "../pages/ManageVietinBank/ManageVietinBank.js";
import ManageTreasure from '../pages/ManageTreasure/ManageTreasure.js';
import CrabGourdJackpotSetting from '../pages/CrabGourdManager/CrabGourdJackpotSetting.js';
import CrabGourdBotSetting from '../pages/CrabGourdManager/CrabGourdBotSetting.js';
import ManageLiveRoomBackground from '../pages/ManageLiveRoomBackground/ManageLiveRoomBackground.js';
import NewUserRoomManager from '../pages/NewUserRoomManager/NewUserRoomManager.js';
import GroupPostPage from '../pages/GroupPostPage/GroupPostPage.js';
import RoomScoringPage from '../pages/RoomScoringPage/RoomScoringPage.js';
import UserTimerLogPage from '../pages/UserTimerLogPage/UserTimerLogPage.js';
import S3UploadPage from '../pages/S3UploadPage/S3UploadPage.js';
import BotTemplatePromptManagerPage from '../pages/BotTemplatePromptManagerPage/BotTemplatePromptManagerPage.js';
import ReferralManagerPage from '../pages/ReferralManagerPage/ReferralManagerPage.js';
import ClearCacheRedisPage from '../pages/ClearCacheRedisPage/ClearCacheRedisPage.js';
import LoginWhitelistPage from '../pages/LoginWhitelistPage/LoginWhitelistPage.js';
import GemExchangeManagementPage from '../pages/GemExchangeManagementPage/GemExchangeManagementPage.js';
import KaraokeManagerPage from '../pages/KaraokeManagerPage/KaraokeManagerPage.js';
import SingerManagerPage from '../pages/KaraokeManagerPage/SingerManagerPage.js';
import SingerModerationPage from '../pages/SingerModerationPage/SingerModerationPage.js';
import KaraokeBeatManagerPage from '../pages/KaraokeManagerPage/BeatManagerPage.js';
import BaseSongManagerPage from '../pages/KaraokeManagerPage/BaseSongManagerPage.js';
import LyricDetectPage from '../pages/LyricDetectPage/LyricDetectPage.js';
import LyricHistoryPage from '../pages/LyricDetectPage/LyricHistoryPage.js';
import RestoreDeletedBeatPage from '../pages/RestoreDeletedBeatPage/RestoreDeletedBeatPage.js';
import BeatModerationPage from '../pages/BeatModerationPage/BeatModerationPage.js';
import RecordingLikeScoresPage from '../pages/RecordingLikeScoresPage/RecordingLikeScoresPage.js';
import UserRecordingsWithStatsPage from '../pages/UserRecordingsWithStatsPage/UserRecordingsWithStatsPage.js';
import AdminRoomEarningPage from './AdminRoomEarningPage.js';
toast.configure();
var site = null;
var wait = true;
class App extends PureComponent {
    constructor(props) {
        super(props);
        this.checkParamLogin();
        // this.checkJwtToken();
        //this.checkParamLogin = this.checkParamLogin.bind(this);
        axios.defaults.withCredentials = true;
        initAuthToken();        // gắn lại Bearer token đã lưu (nếu có)
        setupAuthInterceptor(); // 401/403 → xóa token, yêu cầu đăng nhập lại

        this.updateUser = this.updateUser.bind(this);
        this.reLoginUser = this.reLoginUser.bind(this);
        this.updateUserTemp = this.updateUserTemp.bind(this);
        this.gotoPage = this.gotoPage.bind(this);
        this.openAdminLoginDialogIfNeeded = this.openAdminLoginDialogIfNeeded.bind(this);
        // let user = {
        //  name: "abc",
        //  profileImageLink: "https://data4.ikara.co/data/minio/ikara-data/avatars/513222759149779/513222759149779_200.jpg",
        //  isAdmin: true
        // }

        // let user = {
        //  facebookId: "105912617350916906040",
        //  uid: 6868,
        //  name: "abc",
        //  profileImageLink: "https://data4.ikara.co/data/minio/ikara-data/avatars/513222759149779/513222759149779_200.jpg",
        //  isAdmin: true,
        //  role: "MANAGER"
        // }

        // ($env:HTTPS = "true") -and (npm start)
        this.state = {
            user: null,
            userTemp: null,
            updateUser: this.updateUser,
            updateUserTemp: this.updateUserTemp,
            reLoginUser: this.reLoginUser,
            isAdmin: true,
            registerVipType: "DAY",
            role: null,
            isActive:  false,
            isLoading: true,
            isManager: false
        }

        this.redirect();

    }

updateRegisterVipType(type) {
        this.setState({
            registerVipType: type
        })
    }

    redirect = () => {
        let protocol = window.location.protocol;
        let hostName = window.location.host;
        let port = window.location.port;
        let pathName = window.location.pathname;
        let domains = hostName.split(".");

        // if (hostName.includes("okara.tls")) {
        //  return;
        // }

        if ((domains.length < 3 || protocol == "http:") && !hostName.includes("localhost")) {
            if (domains.length < 3) {
                hostName = "www." + hostName;
            }

            if (protocol == "http:") {
                protocol = "https:"
            }

            let url = protocol + "//" + hostName + pathName;
            window.location.replace(url);
        }
    }


    updateUser(user) {
        this.setState(
            {
                user: user
            }
        )
    }

    updateUserTemp(user) {
        this.setState(
            {
                userTemp: user
            }
        )
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ isLoading: false });
        }, 1200);

        this.reLoginUser();
    }

    componentDidUpdate() {
        this.openAdminLoginDialogIfNeeded();
    }

    openAdminLoginDialogIfNeeded() {
        const { isLoading, user } = this.state;
        if (isLoading || user != null) return;
        if (!isAdminPortalHostname(window.location.hostname)) return;
        const path = window.location.pathname;
        const shouldForceLoginOnAdminEntry =
            path === "/" || path === "/admin/manager-page" || path === "/admin/manager-page/";
        if (!shouldForceLoginOnAdminEntry) return;
        const modal$ = window.$;
        if (modal$ && modal$('#loginDialog').length && !modal$('#loginDialog').hasClass('show') && typeof modal$('#loginDialog').modal === 'function') {
            modal$('#loginDialog').modal({ backdrop: 'static', keyboard: false, show: true });
        }
    }

    reLoginUser() {
        const json = JSON.stringify({ domain: window.location.hostname });

        axios.post(global.config.apiDomain + '/rest/loginuser', json, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            const { user, role, token } = res.data;

            if (user != null) {
                if(role != null){
                    user.role = role;
                }
                applyAuthToken(token);
                // if(user.uid == 4175719 || user.uid == 4370682 ) {
                //  alert(navigator.platform);
                //  alert(navigator.userAgent);
                //  alert(detectMob())
                // }

                this.setState({
                    user: user,
                });

                window.localStorage.setItem("login", true);
                window.localStorage.setItem("userId", user.facebookId);
                window.localStorage.setItem("profileImageLink", user.profileImageLink);
                window.localStorage.setItem("name", user.name);
                window.localStorage.setItem("uid", user.uid);

                setCookie("login", "true", 1);
                setCookie("userId", user.facebookId, 1);
                setCookie("profileImageLink", user.profileImageLink, 1);
                setCookie("name", user.name, 1);
            } else {
                window.localStorage.removeItem("login");
                window.localStorage.removeItem("userId");
                window.localStorage.removeItem("profileImageLink");
                window.localStorage.removeItem("name");

                clearAuthToken();
                deleteAllCookies();

                this.setState({
                    isAdmin: false
                })
            }
        }, err => {
            window.localStorage.removeItem("login");
            window.localStorage.removeItem("userId");

            clearAuthToken();

            this.setState({
                isAdmin: false
            })
        });
    }
      
    checkParamLogin() {
        // if (window.localStorage.getItem("login") == "true"){
        //  console.log("Bạn đã login từ trước!");
        //  return;
        // }
        let self = this;

        const queryParams = new URLSearchParams(window.location.search);
        const parameters = queryParams.get('parameters');
        if (parameters == null) {   
            wait = false;           
            return;
        }

        let isJwt = parameters != null && parameters.split(".").length == 3;

        if(isJwt) {
            axios.get(global.config.apiDomain + '/rest/user/profile', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + parameters
                }
            }).then(res => {
                
                    const { user } = res.data.data;
                    if (user != null) {
                        applyAuthToken(parameters);
                        window.localStorage.setItem("login", true);
                        window.localStorage.setItem("userId", user.facebookUserId);
                        window.localStorage.setItem("profileImageLink", user.profileImageLink);
                        window.localStorage.setItem("name", user.name);
                        setCookie("login", "true", 1);
                        setCookie("userId", user.facebookUserId, 1);
                        setCookie("profileImageLink", user.profileImageLink, 1);
                        setCookie("name", user.name, 1);

                        // Cookie này dùng cho trang sự kiện
                        setCookie("facebookUserId", user.facebookUserId, 1);
                        this.setState({
                            user: user,
                        });
                        return;
                    }
                })
        }

        var base54Code = parameters.split("-");
        if (base54Code == null || base54Code.length == 0 || base54Code[0] == null) {    
            wait = false;               
            return;
        }
        var base = Buffer.from(base54Code[0], 'base64');
        var paramJSON = null;
        try {
            paramJSON = JSON.parse(base.toString());
        } catch (error) {
            console.log(error);
            wait = false;           
            return;
        }
        var deviceID = paramJSON.userId;
        var method = paramJSON.method;  
        site =  paramJSON.site; 
        if (deviceID == null || method != "loginDeviceID") {    
            wait = false;               
            return;
        }
            axios.post(global.config.apiDomain + '/rest/loginuser/loginDeviceID', parameters, {
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(res => {
                console.log("login")
            
                const { user, token } = res.data;
                if (user != null) {
                  applyAuthToken(token);
                  window.localStorage.setItem("login", true);
                  window.localStorage.setItem("userId", user.facebookId);
                  window.localStorage.setItem("profileImageLink", user.profileImageLink);
                  window.localStorage.setItem("name", user.name);
                  setCookie("login", "true", 1);
                  setCookie("userId", user.facebookId, 1);
                  setCookie("profileImageLink", user.profileImageLink, 1);
                  setCookie("name", user.name, 1);
                  console.log(user)
                  this.setState({
                    user: user,
                });

                }
                if (site != null && site != ""){
                    this.gotoPage();
                }else { wait = false;} 

                console.log("ENDlogin")

              })
    }
    checkJwtToken() {
        const queryParams = new URLSearchParams(window.location.search);
        const parameters = queryParams.get('parameters');
        if (parameters == null) {   
            wait = false;           
            return;
        }
        
        try {
            // Decode JWT token
            const jwtParts = parameters.split('.');
            if (jwtParts.length !== 3) {
                console.log('Invalid JWT format');
                wait = false;
                return;
            }
            
            // Decode payload (middle part)
            const payload = jwtParts[1];
            const decodedPayload = JSON.parse(atob(payload));
            
            // Extract facebookUserId from payload
            const facebookUserId = decodedPayload.facebookUserId;
            
            if (facebookUserId) {
                // Save facebookUserId to cookie
                setCookie("facebookUserId", facebookUserId, 1);
            } else {
                console.log('No facebookUserId found in JWT payload');
            }
            
            wait = false;
        } catch (error) {
            console.error('Error decoding JWT token:', error);
            wait = false;
        }
    }
    gotoPage(){
        window.location.replace(site);
        window.location.href = site;
    }

    render() {
       
        const { t } = this.props;
        let isLogin = window.localStorage.getItem("login");
        var { isAdmin, isActive, isLoading, isManager } = this.state;
        if (wait || isLoading)  return (
            <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}>
                <ReactLoading type="bubbles" color={getThemeColor()} height={200} width={100} />
            </div>
        );
        const { user } = this.state;
        if (user != null) {
            isAdmin = user.isAdmin;
            if(user.role == "MANAGER" || user.role == "ICOIN-MANAGER" || user.role == "CUSTOMER-SUPPORTER" || user.role == "SELLER" || user.role == "SINGER" || user.role == "TESTER" || user.role != "COLLABORATOR"){
                isActive = true;
            }
            if(user.role == "MANAGER" || user.role == "ICOIN-MANAGER" || user.role == "CUSTOMER-SUPPORTER"){
                isManager = true;
            }
        }
        const shouldShowAdminOverlay =
            typeof window !== 'undefined' &&
            isAdminPortalHostname(window.location.hostname) &&
            (window.location.pathname === "/" ||
                window.location.pathname === "/admin/manager-page" ||
                window.location.pathname === "/admin/manager-page/") &&
            user == null;

        return (
            <MyContextProvider value={this.state}>
                {/* <FacebookProvider 
                    appId={t("commons.facebook_app_id", "370514506352628")}
                    isMobile={false}
                    > */}
                <Router>
                    <ScrollToTop>
                        <Switch>
                            {/* WebView route - không có header/footer */}
                            <Route path="/contest" component={WebViewPage}></Route>
                            <Route path="/contest/*" component={WebViewPage}></Route>
                            
                            {/* Các route khác có header/footer */}
                            <Route>
                                <Header></Header>
                                <BoxSearch></BoxSearch>
                                <Menu t={t}></Menu>
                                <Switch>
                            <Route
                                exact
                                path="/"
                                render={(routeProps) =>
                                    typeof window !== 'undefined' &&
                                    isAdminPortalHostname(window.location.hostname) ? (
                                        <AdminPage />
                                    ) : (
                                        <HomePage {...routeProps} />
                                    )
                                }
                            />
                            <Route path="/recording/:recordingId" component={RecordingPage}></Route>
                            <Route path="/admin/seller-manager/sellerId/:sellerId" component={SellerId}></Route>
                            <Route path="/react/recording/:recordingId" component={RecordingPage}></Route>
                            {/* <Route path="/liveroom/:liveroomId" component={LiveroomPage}></Route> */}
                            <Route path="/post/:postId" component={PostPage}></Route>
                            {/* <Route path="/react/liveroom/:liveroomId" component={LiveroomPage}></Route> */}
                            <Route path="/user/:userId" component={UserPage}></Route>
                            <Route path="/top-users" component={TopUsersPage}></Route>
                            <Route path="/login">
                                {user ? <Redirect to="/" /> : <LoginPage t={t} />}
                            </Route>
                            <Route path="/my-images" >
                                {isLogin ? <MyImagesPage /> : <Redirect to="/login" />}
                            </Route>
                            <Route path="/my-recordings">
                                {isLogin ? <MyRecordingPage /> : <Redirect to="/login" />}
                            </Route>
                            <Route path="/my-gifts" >
                                {isLogin ? <MyGiftsPage /> : <Redirect to="/login" />}
                            </Route>
                            <Route path="/me">
                                {isLogin ? <ProfilePage /> : <Redirect to="/login" />}
                            </Route>
                            <Route path="/upload-beat">
                                {(isLogin && detectApp("vi")) ? <UploadBeatPage /> : <Redirect to="/login" />}
                            </Route>

                            <Route path="/beat-manager">
                                {(isLogin && detectApp("vi")) ? <BeatManagerPage /> : <Redirect to="/login" />}
                            </Route>
                            
                            <Route path="/linked-account">
                                {(isLogin && detectApp("en.yokara")) ? <LinkedAccountPage /> : <Redirect to="/login" />}
                            </Route>

                            <Route path="/buy-icoin">
                                {isLogin ? <BuyICoinPage /> : <Redirect to="/login" />}
                            </Route>

                            <Route path="/download" component={DownloadPage}></Route>
                            <Route path="/d" component={DownloadPage}></Route>
                            <Route path="/comeback" component={DownloadPage}></Route>
                            <Route path="/mix-recording-console" component={MixRecordingPage}></Route>
                            <Route path="/subscribe-console" component={SubscribeConsoleLogPage}></Route>
                            <Route path="/okara-console" component={OkaraConsoleLogPage}></Route>
                            <Route path="/privacy-policy" component={PrivacyPolicyPage}></Route>
                            <Route path="/term" component={TermPage}></Route>
                            {/*  */}
                            <Route path="/react/privacy-policy" component={PrivacyPolicyPage}></Route>
                            <Route path="/react/term" component={TermPage}></Route>
                            {/*  */}
                            {/* <Route path="/evenlevel" component={EvenLevelPrivilege}></Route> */}
                            <Route path="/vip" component={VipPage}></Route>
                            <Route path="/top-recordings" component={TopRecordingsPage}></Route>
                            <Route path="/top-duet-recordings" component={TopDuetRecordingsPage}></Route>
                            <Route path="/search/:keyword" component={SearchPage}></Route>

                            <Route path="/error500" component={ErrorPage}></Route>
                                        {isActive && <Route path="/admin/evenlevel" component={EvenLevelPrivilege}></Route>}
                            {isActive && <Route path="/admin/promotion-manager" component={PromotionManagerPage}></Route>}
                            {isActive && <Route path="/admin/copyright" component={CopyrightPage}></Route>}
                            {isActive && <Route path="/admin/banner-manager" component={BannerManagerPage}></Route>}
                            {isActive && <Route path="/admin/package-manager" component={PackageManagerPage}></Route>}
                            {isActive && <Route path="/admin/recharge-manager" component={TransactionManagerPage}></Route>}
                            {isActive && <Route path="/admin/support" component={SupportUser}></Route>}
                            {isActive && <Route path="/admin/support-new/:id" component={SupportNewUser}></Route>}
                            {isActive && <Route path="/admin/idol-recording/:id" component={IdolRecording}></Route>}
                            {isActive && <Route path="/admin/bot-recording/:id" component={BotRecording}></Route>}
                            {isActive && <Route path="/admin/gift-manager" component={GiftManagerPage}></Route>}
                            {/* {isActive && <Route path="/admin/cup-manager" component={UpdateCupPage}></Route>} */}
                            {isActive && <Route path="/admin/icon-event-manager" component={AddIconForEventPage}></Route>}
                            {isActive && <Route path="/admin/special-gift" component={SpecialGiftDiscountPage}></Route>}
                            {isActive && <Route path="/admin/rank-gift" component={RankGiftPage}></Route>}
                            {isManager && <Route path="/admin/push-notification" component={NotifyPage}></Route>}
                            {isActive && <Route path="/admin/push-notify" component={PushNotificationPage}></Route>}
                            {isActive && <Route path="/admin/lucky-money-manager" component={LuckyGiftManagerPage}></Route>}
                            {isActive && <Route path="/admin/post-fanpage" component={PostFanpagePage}></Route>}
                            {isActive && <Route path="/admin/minigame-manager" component={MinigameManagerPage}></Route>}
                            {isActive && <Route path="/admin/generateLink" component={GenerateLinkPage}></Route>}
                            {isActive && <Route path="/notify-management" component={NotifyManagement}></Route>}
                            {isActive && <Route path="/admin/itemShop-manager" component={AvatarFrame}></Route>}
                            {isActive && <Route path="/admin/itemShopCommentFrame-manager" component={CommentFrame}></Route>}
                            {isActive && <Route path="/admin/itemShopRoomEntryEffect-manager" component={RoomEntryEffect}></Route>}
                            {isActive && <Route path="/admin/itemShop-user-decor-manager" component={UserDecoration}></Route>}
                            {isActive && <Route path="/admin/personal-card" component={PersonalCard}></Route>}
                            {isActive && <Route path="/admin/sing-effect" component={SingEffect}></Route>}
                            {isActive && <Route path="/admin/rank-items" component={RankItemPage}></Route>}
                            {isActive && <Route path="/admin/vip-privileges" component={VipPrivilege}></Route>}
                            {isActive && <Route path="/admin/banner-full" component={BannerFullPageManager}></Route>}
                            {isActive && <Route path="/admin/top-vip" component={TopVipUserOfThisMonth}></Route>}
                            {isActive && <Route path="/admin/test" component={TestPage}></Route>}
                            {isActive && <Route path="/angular/logcat.html"></Route>}
                            {isActive && <Route path="/admin/set-privilege-admin" component={SetPrivilegeAdmin}></Route>}
                            {isActive && <Route path="/admin/lucky-gift-manager" component={LuckyGiftManager}></Route>}
                            {isActive && <Route path="/admin/level-privilege" component={LevelPrivilege}></Route>}
                            {isActive && <Route path="/admin/couple" component={CouplePage}></Route>}
                            {isActive && <Route path="/admin/decoration-item-types" component={DecorationItemType}></Route>}
                            {isActive && <Route path="/admin/medal-manager" component={MedalManagerPage}></Route>}
                            {isActive && <Route path="/admin/deep-ar-filter" component={DeepARFilterPage}></Route>}
                            {isActive && <Route path="/admin/deep-ar-effect" component={DeepAREffectPage}></Route>}
                            {isActive && <Route path="/admin/gift-deleted" component={DeletedGiftPage}></Route>}
                            {isActive && <Route path="/admin/birthday-gift" component={BirthdayGiftManager}></Route>}
                            {isActive && <Route path="/admin/screen-manager" component={ScreenManagerPage}></Route>}
                            {isActive && <Route path="/admin/app-policy" component={AppPolicyPage}></Route>}
                            {isActive && <Route path="/admin/survey" component={SurveyPage}></Route>}
                            {isActive && <Route path="/admin/cup-history" component={SendCupHistoryPage}></Route>}
                            {isActive && <Route path="/admin/account-manager" component={AccountManagerPage}></Route>}
                            {isActive && <Route path="/admin/game-manager/create-game-type" component={CreateAndUpdateGameTypePage}></Route>}
                            {isActive && <Route path="/admin/game-manager/create-game-level" component={CreateAndUpdateGameLevelPage}></Route>}
                            {isActive && <Route path="/admin/game-manager/level/:gameLevelId" component={CreateAndUpdateGameLevelPage}></Route>}
                            {isActive && <Route path="/admin/game-manager/type/:gameTypeId" component={CreateAndUpdateGameTypePage}></Route>}
                            {isActive && <Route path="/admin/game-manager" component={GameManagerPage}></Route>}
                            {true && <Route path="/admin/recording-ai/add" component={AddRecordingVipPage}></Route>}
                            {true && <Route path="/admin/recording-ai/detail/:recordingId" component={DetailRecordingVipPage}></Route>}
                            {true && <Route path="/admin/recording-ai" component={RecordingVipPage}></Route>}
                            {true && <Route path="/admin/recording-vip-statitics" component={RecordingVipStatiticPage}></Route>}
                            {isActive && <Route path="/admin/user-special-gift" component={UserSpecialGiftPage}></Route>}
                            {isActive && <Route path="/admin/categories" component={YoutubeSong}></Route>}
                            {isActive && <Route path="/admin/theVoiceExamnerPage" component={TheVoiceExamnerPage}></Route>}
                            {isActive && <Route path="/admin/item3D" component={Item3DPage}></Route>}
                            {isActive && <Route path="/admin/livestream" component={LivestreamPage}></Route>}
                            {isActive && <Route path="/admin/recording-vip-users" component={RecordingVipUsers}></Route>}
                            {isActive && <Route path="/admin/content-event" component={ContentEventPage}></Route>}
                            {isActive && <Route path="/admin/feature-request" component={FeatureRequestPage}></Route>}
                            {isActive && <Route path="/admin/user-post" component={UserPostPage}></Route>}
                            {isActive && <Route path="/admin/hashtag" component={HashtagPage}></Route>}
                            {isActive && <Route path="/admin/real-gift-manager" component={RealGiftPage}></Route>}
                            {isActive && <Route path="/admin/contests" component={CompetitionPage}></Route>}
                            {isActive && <Route path="/admin/rooms-event" component={RoomEventPage}></Route>}
                            {isActive && <Route path="/admin/banner-sell-mic" component={BannerSellMicPage}></Route>}
                            {isActive && <Route path="/admin/promo-banner-sell-mic" component={PromoBannerSellMicPage}></Route>}
                            {isActive && user.role === "SELLER" && <Route path="/admin/seller-manager" component={SellerPage} />}
                            {isActive && user.role === "MANAGER" && <Route path="/admin/seller-manager" component={ManagerSellerPage} />}
                            {isActive && <Route path="/admin/new-device-every-day/:id" component={ManagerNewDevice} />}
                            {isActive && <Route path="/admin/pin-mv-outstand" component={ManagerHotMv} />}
                            {isActive && <Route path="/admin/dead-account-manager" component={ManagerDeadAccount} />}
                            {isActive && <Route path="/admin/list-recordings/:uid" component={ListRecordingOfAccount} />}
                            {isActive && <Route path="/admin/midi-recording/:id" component={MidiRecordingDetail} />}
                            {isActive && <Route path="/admin/botmanager" component={BOTManagerPage}></Route>}
                            {isActive && <Route path="/admin/botfollow/:id" component={BOTFollowing}></Route>}
                            {isActive && <Route path="/admin/bot-interact-manager" component={BOTInteractManagerPage}></Route>}
                            {isActive && <Route path="/admin/bot-live-room-manager" component={BOTLiveRoomManagerPage}></Route>}
                            {isActive && <Route path="/admin/customer-support-bot" component={CustomerSupportBotPage}></Route>}
                            {isActive && <Route path="/admin/top-beat-recording" component={TopBeatPage} />}
                            {isActive && <Route exact path="/admin/list-chat" render={() => <Redirect to="/admin/list-chat/yokara" />} />}
                            {isActive && <Route path="/admin/list-chat/:official" render={(props) => (
                                <ListChatSupportUser key={props.match.params.official} {...props} />
                            )} />}
                            {isActive && <Route path="/admin/idolmanager" component={IdolManagerPage}></Route>}
                            {isActive && <Route path="/admin/AvatarChangePage" component={AvatarChangePage}></Route>}
                            {isActive && <Route path="/admin/daily-task" component={DailyTaskPage}></Route>}
                            {isActive && <Route path="/admin/midi-score" component={MidiRecordingPage}></Route>}
                            {isActive && <Route path="/admin/top_video_recording" component={TopVideoRecordingPage}></Route>}
                            {isActive && <Route path="/admin/surveyNPS" component={SurveyNPSPage}></Route>}

                            {true && <Route path="/admin/manager-page" component={AdminPage}></Route>}
                            {true && <Route path="/admin/recheck-apple" component={RecheckApplePage}></Route>}
                            {true && <Route path="/admin/youtube-midi/add" component={AddYoutubeMidiPage}></Route>}
                            {true && <Route path="/admin/youtube-midi/detail/:youtubeId" component={DetailYoutubeMidiPage}></Route>}
                            {true && <Route path="/admin/youtube-midi" component={YoutubeMidiPage}></Route>}
                            {isActive && <Route path="/admin/gift-level-manager" component={GiftLevelManagerPage}></Route>}
                            {isActive && <Route path="/admin/client-log" component={ClientLogPage}></Route>}
                            {isActive && <Route path="/admin/client-log-detail/:id" component={ClientLogDetailPage}></Route>}
                            {isActive && <Route path="/admin/dice-game-info-history" component={DiceGameInfoHistory}></Route>}
                            {isActive && <Route path="/admin/dice-user-history" component={DiceUserHistoryPage}></Route>}
                            {isActive && <Route path="/admin/dice-bet-client-fails" component={DiceBetClientFailsPage}></Route>}
                            {isActive && <Route path="/admin/virtual-background" component={VirtualBackgroundPage}></Route>}
                            {isActive && <Route path="/admin/smartlook-manager" component={SmartLookManager}></Route>}
                            {isActive && <Route path="/admin/live-room-info" component={LiveRoomInfo}></Route>}
                            {isActive && <Route path="/admin/partner" component={PartnerManagerPage}></Route>}
                            {isActive && <Route path="/admin/icoin-detail/:uid" component={PartnerIcoinDetail}></Route>}
                            {isActive && <Route path="/admin/winrate-fish-hunter" component={WinRateFishHunterPage}></Route>}
                            {isActive && <Route path="/admin/bank-account-manager" component={ManageVietcomBank}></Route>}
                            {isActive && <Route path="/admin/manage-vietinbank" component={ManageVietinBank}></Route>}
                            {isActive && <Route path="/admin/treasure-manager" component={ManageTreasure}></Route>}
                            {isActive && <Route path="/admin/crab-gourd-jackpot-setting" component={CrabGourdJackpotSetting}></Route>}
                            {isActive && <Route path="/admin/crab-gourd-bot-setting" component={CrabGourdBotSetting}></Route>}
                            {isActive && <Route path="/admin/manage-live-room-background" component={ManageLiveRoomBackground}></Route>}
                            {isActive && <Route path="/admin/new-user-room-manager" component={NewUserRoomManager}></Route>}
                            {isActive && <Route path="/admin/group-posts" component={GroupPostPage}></Route>}
                            {true && <Route path="/admin/room-scoring" component={RoomScoringPage}></Route>}
                            {isActive && <Route path="/admin/user-timer-log" component={UserTimerLogPage}></Route>}
                            {isActive && <Route path="/admin/s3-upload" component={S3UploadPage}></Route>}
                            {isActive && <Route path="/admin/template-bot-prompt-manager" component={BotTemplatePromptManagerPage}></Route>}
                            {isActive && <Route path="/admin/referral-manager" component={ReferralManagerPage}></Route>}
                            {isActive && <Route path="/admin/clear-cache-redis" component={ClearCacheRedisPage}></Route>}
                            {isActive && <Route path="/admin/login-whitelist" component={LoginWhitelistPage}></Route>}
                            {isActive && <Route path="/admin/restore-deleted-beat" component={RestoreDeletedBeatPage}></Route>}
                            {isActive && <Route path="/admin/recording-like-scores" component={RecordingLikeScoresPage}></Route>}
                            {isActive && <Route path="/admin/user-recordings-with-stats" component={UserRecordingsWithStatsPage}></Route>}
                            {isActive && <Route path="/admin/gem-exchange-management" component={GemExchangeManagementPage}></Route>}
                            {isActive && <Route path="/admin/room-make-money" component={AdminRoomEarningPage}></Route>}
                            {isActive && <Route exact path="/admin/lyric-detect" component={LyricDetectPage}></Route>}
                            {isActive && <Route exact path="/admin/lyric-history" component={LyricHistoryPage}></Route>}
                            {isActive && <Route exact path="/admin/karaoke-manager" component={KaraokeManagerPage}></Route>}
                            <Route exact path="/admin/beat-manager/singer-moderation">
                                {isActive ? <SingerModerationPage /> : <Redirect to="/login" />}
                            </Route>
                            <Route exact path="/admin/beat-manager/beat-moderation">
                                {isActive ? <BeatModerationPage /> : <Redirect to="/login" />}
                            </Route>
                            {isActive && <Route path="/admin/karaoke-manager/singer" component={SingerManagerPage}></Route>}
                            {isActive && <Route path="/admin/karaoke-manager/beat" component={KaraokeBeatManagerPage}></Route>}
                            {isActive && <Route path="/admin/karaoke-manager/base-song" component={BaseSongManagerPage}></Route>}
                            <Route component={NotFoundPage}></Route>
                                </Switch>
                                <Footer></Footer>
                                
                                {/* SingButton chỉ hiển thị cho các trang khác, không phải webview */}
                                {(detectApp("lo.okara") || detectApp("localhost") || detectApp("my.okara")) && (
                                    <SingButton></SingButton>
                                )}
                                {shouldShowAdminOverlay && (
                                    <div
                                        style={{
                                            position: 'fixed',
                                            inset: 0,
                                            backgroundColor: '#f5f5f5', // nền trơn trung tính, đục hoàn toàn — ẩn hẳn nội dung phía sau
                                            zIndex: 1040
                                        }}
                                    />
                                )}
                                
                                {/* Dialog components chỉ hiển thị cho các trang khác, không phải webview */}
                                {user != null ?
                                    <>
                                        <UnsubscribeOkaraDialog></UnsubscribeOkaraDialog>
                                        <SubscribeOkaraDialog></SubscribeOkaraDialog>
                                        <ConfirmSubscribeOkaraDialog></ConfirmSubscribeOkaraDialog>
                                    </> 
                                    :
                                    <>
                                        <PhoneVetificationDialog></PhoneVetificationDialog>
                                        <ConfirmPhoneVetificationDialog></ConfirmPhoneVetificationDialog>
                                        <LoginDialog></LoginDialog>
                                        <RegisterPhoneDialog></RegisterPhoneDialog>
                                    </>
                                }
                            </Route>
                        </Switch>

                    </ScrollToTop>
                </Router>
                {/* </FacebookProvider> */}
                
                
            </MyContextProvider>
        )
    }
}
export default withTranslation()(App)

App.propTypes = {

};


